import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-return-item',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './return-item.component.html',
  styleUrl: './return-item.component.scss'
})
export class ReturnItemComponent {
  constructor(
    private router: Router
  ) { }

  continue() {
    this.router.navigateByUrl('/orders/return-item/:ref')
  }
}
